import * as am4core from "@amcharts/amcharts4/core";

export const AMCHARTS_LICENSE_KEY = "CH269599249";

am4core.addLicense(AMCHARTS_LICENSE_KEY);
